<template>
    <div class="annt-user-wrapper">
        <el-dropdown @command="handleUserCommand" trigger="click" placement="bottom-end">
            <div class="dropdown-title">
                <el-button
                    type="text"
                    class="user-name"
                    :icon="`${user && user.picUrl ? '' : 'icon iconfont icon-button icon-gerenzhongxinicon'}`">
                    <img v-if="user && user.picUrl" :src="user.picUrl" class="user-portrait" alt="" />
                    {{ user ? user.userName : '' }}
                </el-button>
            </div>
            <template #dropdown>
                <div class="apps-select-dropdown">
                    <el-dropdown-item v-if="showUserCenter" command="userCenter" class="userInfo">
                        个人中心
                    </el-dropdown-item>
                    <el-dropdown-item command="resetPassword" class="userInfo">修改密码</el-dropdown-item>
                    <el-dropdown-item command="logout" class="userInfo">退出登录</el-dropdown-item>
                </div>
            </template>
        </el-dropdown>
        <el-dialog
            v-model="resetPasswordDialog"
            custom-class="forget-password-dialog"
            width="400px"
            top="100px"
            title="修改密码"
            :close-on-click-modal="false"
            :append-to-body="true"
            @close="closeDialog">
            <div class="shortMess">
                <div class="filed">
                    <el-form :model="resetFrom" label-width="90px" ref="resetFromRef" :rules="rules">
                        <el-form-item class="filed-panel" label="旧密码" prop="oldPasswordText">
                            <el-input
                                type="text"
                                class="reset-input"
                                style="display: none"
                                name="oldPasswordText"></el-input>
                            <el-input
                                autocomplete="off"
                                v-model="resetFrom.oldPasswordText"
                                type="password"
                                name="oldPasswordText"
                                placeholder="请输入旧密码" />
                        </el-form-item>
                        <el-form-item class="filed-panel" label="新密码" prop="newPasswordText">
                            <el-input
                                autocomplete="off"
                                v-model="resetFrom.newPasswordText"
                                type="text"
                                name="newPasswordText"
                                placeholder="请输入8~15位包含大小写字母+数字+字符的密码"
                                style="
                                    -webkit-text-security: disc;
                                    -o-text-security: disc;
                                    -moz-text-security: disc;
                                    text-security: disc;
                                " />
                        </el-form-item>
                        <el-form-item
                            class="filed-panel"
                            label="确认新密码"
                            placeholder="请再次输入新密码"
                            prop="sureNewPasswordtext">
                            <el-input
                                autocomplete="off"
                                name="sureNewPasswordtext"
                                style="
                                    -webkit-text-security: disc;
                                    -o-text-security: disc;
                                    -moz-text-security: disc;
                                    text-security: disc;
                                "
                                type="text"
                                v-model="resetFrom.sureNewPasswordtext" />
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <template v-slot:footer class="dialog-footer">
                <el-button type="primary" @click="submitResetPassword">确定</el-button>
                <el-button @click="closeDialog">{{ isUseComplexPassword ? '取消' : '返回登录' }}</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { Logout, resetPassWord } from '@/api/login.js'
import { mapGetters, useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { removeToken } from '@/utils/auth'
import { ref, reactive, onMounted } from 'vue'
import md5 from 'js-md5'
import { ElMessage } from 'element-plus'
import { includeChinese, complexPasswordPattern } from '@/shared/regExp.js'

export default {
    name: 'AnntUser',
    props: {
        targetRoute: {
            type: String,
            default: '/user-center',
        },
        showUserCenter: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['user']),
    },
    // eslint-disable-next-line max-lines-per-function
    setup(props) {
        onMounted(() => {
            // 是否使用复杂密码
            const _isUseComplexPassword = sessionStorage.getItem('isUseComplexPassword')
            // console.log('_isUseComplexPassword...', _isUseComplexPassword);
            isUseComplexPassword.value = +_isUseComplexPassword === 1
            // 未使用复杂密码，弹出修改密码弹框
            if (!isUseComplexPassword.value) {
                ElMessage.warning('当前登录账号的密码为弱密码，请修改为复杂密码')
                setTimeout(() => {
                    resetPasswordDialog.value = true
                }, 1000)
            }
        })
        const router = useRouter()
        const resetPasswordDialog = ref(false)
        const isUseComplexPassword = ref(false)
        const store = useStore()
        const resetFromRef = ref(null)
        const resetFrom = reactive({
            mobile: '',
            oldPasswordText: '',
            newPasswordText: '',
            sureNewPasswordtext: '',
        })
        const validatePassword = (rule, value, callback) => {
            if (!value || (value && /^.{8,15}$/.test(value))) {
                if (complexPasswordPattern.test(value)) {
                    if (includeChinese.test(value)) {
                        callback(new Error('密码不能包含中文'))
                    } else {
                        callback()
                    }
                } else {
                    callback(new Error('密码必须包含数字，大小写字母和字符'))
                }
            } else {
                callback(new Error('请输入8~15位密码'))
            }
        }
        /* 输入校验 */
        const rules = reactive({
            oldPasswordText: [
                { required: true, message: '请输入旧密码' },
                { type: 'string', message: '请输入旧密码' },
            ],
            newPasswordText: [
                { required: true, message: '请输入新密码', trigger: ['blur', 'change'] },
                { validator: validatePassword, trigger: ['blur', 'change'] },
            ],
            sureNewPasswordtext: [
                { required: true, message: '请再次输入新密码', trigger: ['blur', 'change'] },
                {
                    validator: (rule, value, callback) => {
                        if (value !== resetFrom.newPasswordText) {
                            callback(new Error('两次密码不一致'))
                        } else {
                            callback()
                        }
                    },
                    trigger: ['blur', 'change'],
                },
            ],
        })
        /* 判断执行功能 */
        const handleUserCommand = command => {
            if (command === 'logout') {
                Logout().then(res => {
                    if (res && +res.code === 0) {
                        removeToken()
                        /** 退出登录后，也要清空全局的会计主体数据。
                         * 为了处理请求头传了['Entity-Code']字段后产生的bug，复现步骤：
                         *  1. 先A浏览器登录账号；
                            2. 接着B浏览器登录同一个账号；
                            3. 然后B浏览器退出登录；
                            4. 回到A浏览器按F5刷新页面，会被踢下线（以前也会，所以不当做bug），然后重新登录同一个账号，然后切换会计主体；
                            5. 回到B浏览器，再次登录同一个账号会失败，接口会报错msg: "当前会计主体已变更，请刷新页面后重试"。
                        */
                        store.commit('updateAccountingEntity', {})

                        router.push('/login')
                    }
                })
            }
            if (command === 'userCenter' && store.state.user.user.currentTenant) {
                router.push(props.targetRoute)
            }
            if (command === 'resetPassword') {
                resetPasswordDialog.value = true
            }
        }
        /* 重置密码 */
        const submitResetPassword = () => {
            resetFromRef.value.validate(valid => {
                if (!valid) {
                    return false
                }
                resetFrom.mobile = store.state.user.user.contactsMobile
                resetFrom.id = store.state.user.user.contactsId
                resetFrom.oldPassword = md5(resetFrom.oldPasswordText)
                resetFrom.newPassword = md5(resetFrom.newPasswordText)
                resetFrom.sureNewPassword = md5(resetFrom.sureNewPasswordtext)
                resetPassWord(resetFrom).then(res => {
                    if (res && +res.code === 0) {
                        removeToken()
                        router.push('/login')
                        ElMessage.success('修改成功')
                    }
                })
            })
        }
        const closeDialog = () => {
            resetPasswordDialog.value = false
            // 未使用复杂密码，关闭弹框时，退出并返回登录
            if (!isUseComplexPassword.value) {
                Logout().then(res => {
                    if (res && +res.code === 0) {
                        removeToken()
                        router.push('/login')
                    }
                })
            }
        }
        // function validatorPassword(rule, value, callback) {
        //     console.log(rule, value, '878787');
        //     callback(new Error('请输入旧密码'));
        // }
        return {
            handleUserCommand,
            router,
            resetPasswordDialog,
            isUseComplexPassword,
            rules,
            resetFrom,
            submitResetPassword,
            store,
            validatePassword,
            resetFromRef,
            closeDialog,
        }
    },
}
</script>

<style lang="less">
.annt-user-wrapper {
    .user-portrait {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        margin-bottom: -3px;
        margin-right: 5px;
    }
}
</style>
<style lang="less" scoped>
/deep/.el-form-item--mini.el-form-item {
    height: 40px;
    .el-input {
        height: 100%;
        line-height: 40px;
        .el-input__inner {
            height: 100%;
            line-height: 40px;
        }
    }
}
.filed-panel {
    position: relative;
    /deep/.el-form-item__label {
        line-height: 40px;
    }
    .reset-input {
        position: absolute;
    }
}
</style>
